
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import _ from 'lodash';
import {ElForm} from "element-ui/types/form";
import {bindShouGong, getInvoiceAllocateRecord, pageInvoice} from "@/api/invoice/index";
import Decimal from 'decimal.js';
import {constParser} from "@/filters";
import {INVOICE_TYPE} from "@/constant";

@Component({
  name: 'BindInvoice',
  components: {Pagination}
})
export default class BindInvoice extends Vue {

  private showDialog = false;
  private loading = false;
  private options = {
    title: "",
    id: "",
    factoryName: null,
    amount: 0,
    company: null,
    factoryId: null
  }
  private list = [
    {
      label: "已分配金额",
      prop: "allocateAmount",
      key: "allocateAmount"
    },
    {
      label: "本次分配金额",
      prop: "curAllocateAmount",
      key: "curAllocateAmount"
    }
  ];
  private readForm = {
    allocateAmount: 0,
    curAllocateAmount: 0,
  }
  //S/N	发票号码	增值税发票号码	发票品名	发票类型	发票金额	单位	未分配金额	本次分配金额
  private tableCol = [
    {
      label: "发票号码",
      prop: "receiptCode",
      key: "receiptCode",
    },
    {
      label: "增值税发票号码",
      prop: "taxInvoiceCode",
      key: "taxInvoiceCode",
      render: (prop, row) => {
        return row.extMap?.taxInvoiceCode
      }
    },
    {
      label: "发票品名",
      prop: "projectName",
      key: "projectName",
      render: (prop, row) => {
        return row.extMap?.productName
      }
    },
    {
      label: "发票类型",
      prop: "type",
      key: "type",
      render: (prop, row) => {
        return constParser(row.extMap?.type, INVOICE_TYPE);
      }
    },
    {
      label: "发票金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "数量及单位",
      prop: "unit",
      key: "unit",
      render: (prop, row) => {
        return row.extMap?.num + row.extMap?.unit;
      }
    },
    {
      label: "已分配金额",
      prop: "totalAllocateAmount",
      key: "totalAllocateAmount",
    },
    {
      label: "本次分配金额",
      prop: "allocateAmount",
      key: "allocateAmount",
      type: "inputNumber",
      width: 120,
      precision: 4,
      _disabled: '_disabled',
      check: {
        prefix: "list",
        rules: [
          {
            required: true,
            message: '请输入本次分配金额',
            trigger: 'blur'
          },
          // 不能小于等于0
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('不能小于等于0'));
              } else {
                callback();
              }
            }
          }

        ]
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          type: "delete",
          code: "",
          click: "handleRemove",
        },
        // {
        //   name: "修改金额",
        //   code: "",
        //   click: "handleUpdate",
        // }
      ],
      width: 120,
    },
  ]
  private table = {
    list: [] as any[],
  };

  private selectLoading = false;
  private selectInvoice = {};
  private invoiceOptions = [];
  private selectPage = {
    pageNumber: 1,
    pageSize: 20,
    pagerCount: 5,
    total: 0,
  };
  private selectQuery = ''

  public remoteMethod = _.throttle(this.remoteMethod0, 1000);

  public remoteMethod0(query) {
    this.selectLoading = true;
    if (this.selectQuery != query) {
      this.selectPage.pageNumber = 1;
      this.selectQuery = query;
    }
    const param = {
      code: this.selectQuery,
      factoryId: this.options.factoryId,
      company: this.options.company};
    const page = {...this.selectPage};
    pageInvoice(param, page)
        .then(({data}) => {
          const content = data.list
          this.invoiceOptions = content.filter(item => {
            return this.table.list.find(i => i.receiptId === item.id) === undefined
          }).map(item => {
            const projectNames = item.projectName.split(',');
            let label = '';
            if (projectNames.length <= 3) {
              label = `${item.code}  ${item.projectName} | 未分配金额 ${item.unAllocateAmount}元`;
            } else {
              label = `${item.code} ${projectNames.slice(0, 3).join(',')}等 | 未分配金额 ${item.unAllocateAmount}元`
            }
            return {
              id: item.id,
              receiptId: item.id,
              label: label,
              receiptCode: item.code,
              type: "INVOICE",
              amount: item.amount,
              totalAllocateAmount: new Decimal(item.amount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
              allocateAmount: item.unAllocateAmount,
              maxProp: item.unAllocateAmount,
              extMap: {
                num: item.num,
                taxInvoiceCode: item.taxInvoiceCode,
                type: item.type,
                unit: item.units,
                productName: item.projectName,
              }
            }
          })
          this.selectPage.total = Number(data.total)
        })
        .finally(() => this.selectLoading = false)
  }

  public changeSelectPage(val) {
    this.selectPage.pageNumber = val
    this.remoteMethod(this.selectQuery)
  }

  private async getList() {
    this.loading = true;
    getInvoiceAllocateRecord({factoryInvoiceId: this.options.id})
        .then(({data}) => {
          this.table.list = data.map(item => {
            item.maxProp = new Decimal(item.amount).add(new Decimal(item.allocateAmount))
                .sub(new Decimal(item.totalAllocateAmount)).toNumber();
            if (item.extMap?.reconciliationStatus == 'COMPLETED') {
              item['_disabled'] = true;
            }
            return item;
          });
          this.handleInputChange();
        })
        .finally(() => this.loading = false)
  }

  public handleInputChange() {
    let decimal = new Decimal(0);
    this.table.list.forEach(item => {
      decimal = decimal.add(new Decimal(item.allocateAmount))
      return item;
    })
    this.readForm.curAllocateAmount = decimal.toNumber();
  }

  public handleAddInvoice() {
    if (this.table.list.find(item => item.receiptId == this.selectInvoice) === undefined) {
      const obj = Object.assign({}, this.invoiceOptions.find(item => item.id === this.selectInvoice))
      if (obj) {
        let totalAllocateAmount = new Decimal(0);
        this.table.list.forEach(i => {
          totalAllocateAmount = totalAllocateAmount.add(new Decimal(i.allocateAmount))
        })
        obj.allocateAmount = Math.min(obj.allocateAmount, new Decimal(this.options.amount).sub(totalAllocateAmount).toNumber())
        this.table.list.push(obj)
        this.handleInputChange();
      }
    }
  }

  public handleRemove({row}) {
    this.table.list = this.table.list.filter(item => item.id !== row.id)
    this.handleInputChange();
  }

  private confirmLoading = false;

  public handleSubmit() {
    this.confirmLoading = true;
    (this.$refs.form as ElForm).validate(async (valid) => {
      try {
        if (valid) {
          await bindShouGong({
            factoryInvoiceId: this.options.id,
            allocateReceipts: this.table.list,
          });
          this.showDialog = false;
          this.$emit("confirm")
        }
      } finally {
        this.confirmLoading = false
      }
    });
  }

  public async openDialog(obj, options) {
    this.reset()
    this.options = options;
    this.options.id = obj.id;
    this.options.factoryName = obj.factoryName;
    this.options.amount = obj.totalAmount;
    this.options.company = obj.company;
    this.readForm.allocateAmount = new Decimal(obj.totalAmount).sub(new Decimal(obj.unAllocateAmount)).toNumber()
    this.showDialog = true;
    this.options.factoryId = obj.factoryId;
    this.getList()
  }

  public reset() {
    this.invoiceOptions = []
    this.selectInvoice = null;
  }
}
